/*
 * The title and line a client sees for their link: in a phone's text preview (the server's page, billing/link-preview.ts)
 * and on the browser tab (Public.tsx). Written to get the tap, never "Steward" (owner, 2026-11-02: "the pages on preview
 * just say steward as the name, fix that to say something else also more converting for, quotes, reviews, invoices").
 */
export type ClientLinkKind = "invoice" | "quote" | "review" | "report" | "card";

export function clientLinkTitle(
  kind: ClientLinkKind,
  v: { brand: string; number?: number | null; first?: string | null },
): { title: string; description: string } {
  const brand = v.brand.trim() || "your pro";
  const first = v.first?.trim();
  if (kind === "invoice")
    return {
      title: `Invoice${v.number ? ` #${String(v.number)}` : ""} from ${brand}`,
      description: "See your invoice and pay in a minute. Thank you for choosing us.",
    };
  if (kind === "quote")
    return {
      title: `${first ? `${first}, your` : "Your"} quote from ${brand} is ready`,
      description: "See your price and say yes in one tap.",
    };
  if (kind === "review")
    return {
      title: `${first ? `${first}, how` : "How"} did we do? · ${brand}`,
      description: "Tap a star. It takes 20 seconds and helps our local team a lot.",
    };
  if (kind === "report")
    return { title: `Your visit report from ${brand}`, description: "See the photos and what we did on your visit." };
  return { title: `Save your card with ${brand}`, description: "Kept safe with Stripe. Takes a minute." };
}
